import React from "react";

/**
 * AK Modlar yonetimi (Mod 1, Mod 2, Pazar Gunu vb)
 * - Duzenleme secimi
 * - Aktif etme
 * - Yeni mod ekleme
 * - Isim degistirme
 * - Silme
 */
const AkModesManager = ({
  modes,
  activeMode,
  editingMode,
  renamingMode,
  renameValue,
  onSetEditingMode,
  onSetActiveSubMode,
  onAddSubMode,
  onStartRename,
  onSaveRename,
  onCancelRename,
  onRenameValueChange,
  onDeleteSubMode,
}) => (
  <div style={{ background: '#e4e4e4', borderRadius: 10, padding: 14, marginBottom: 12, border: '1px solid #e5e7eb' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
      <h3 style={{ margin: 0, color: '#09301E', fontSize: 14 }}>🗂️ Modlar</h3>
      <button onClick={onAddSubMode} data-testid="ak-add-mode-btn"
        style={{ padding: '8px 14px', background: '#27ae60', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 700, fontSize: 13 }}>
        + Yeni Mod Ekle
      </button>
    </div>
    <p style={{ fontSize: 11, color: '#64748b', margin: '0 0 10px' }}>
      Aşağıdaki modlardan birine tıklayarak <strong>düzenle</strong>. Aktif etmek için kart üzerindeki "Aktif Et" butonunu kullan.
    </p>

    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 10 }}>
      {modes.map(m => {
        const isEditing = editingMode === m.id;
        const isActiveMode = activeMode === m.id;
        return (
          <div key={m.id} style={{
            background: isEditing ? '#fff8ee' : '#e4e4e4',
            border: `2px solid ${isEditing ? '#DA9F54' : (isActiveMode ? '#22c55e' : '#e5e7eb')}`,
            borderRadius: 8, padding: 10, transition: 'all 0.2s',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, flex: 1, minWidth: 0 }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: '#09301E', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {m.name}
                </span>
                {isActiveMode && (
                  <span style={{ background: '#22c55e', color: '#fff', fontSize: 9, fontWeight: 700, padding: '2px 6px', borderRadius: 10, textTransform: 'uppercase' }}>Aktif</span>
                )}
              </div>
              <div style={{ display: 'flex', gap: 3 }}>
                <button onClick={() => onStartRename(m)} title="İsim Değiştir"
                  style={{ background: 'transparent', border: 'none', cursor: 'pointer', padding: 3, fontSize: 13 }}>✎</button>
                <button onClick={() => onDeleteSubMode(m.id)} title="Sil" disabled={modes.length <= 1}
                  style={{ background: 'transparent', border: 'none', cursor: modes.length <= 1 ? 'not-allowed' : 'pointer', padding: 3, fontSize: 13, opacity: modes.length <= 1 ? 0.3 : 1, color: '#e74c3c' }}>✕</button>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={() => onSetEditingMode(m.id)} disabled={isEditing}
                style={{ flex: 1, padding: '7px 8px', fontSize: 11, fontWeight: 700, borderRadius: 5, border: 'none', cursor: isEditing ? 'default' : 'pointer',
                        background: isEditing ? '#DA9F54' : '#f1f5f9', color: isEditing ? '#000' : '#475569' }}
                data-testid={`ak-edit-mode-${m.id}`}>
                {isEditing ? '✎ Düzenleniyor' : 'Düzenle'}
              </button>
              <button onClick={() => onSetActiveSubMode(m.id)} disabled={isActiveMode}
                style={{ flex: 1, padding: '7px 8px', fontSize: 11, fontWeight: 700, borderRadius: 5, border: 'none',
                        cursor: isActiveMode ? 'default' : 'pointer',
                        background: isActiveMode ? '#22c55e' : '#3b82f6',
                        color: '#fff', opacity: isActiveMode ? 0.85 : 1 }}
                data-testid={`ak-activate-mode-${m.id}`}>
                {isActiveMode ? '✓ Aktif' : '🚀 Aktif Et'}
              </button>
            </div>
          </div>
        );
      })}
    </div>

    {renamingMode && (
      <div style={{ marginTop: 10, padding: 10, background: '#f8fafc', borderRadius: 6, display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ fontSize: 12, color: '#475569', fontWeight: 600 }}>Yeni isim:</span>
        <input value={renameValue} onChange={e => onRenameValueChange(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') onSaveRename(renamingMode); }}
          style={{ padding: '7px 10px', border: '2px solid #DA9F54', borderRadius: 6, fontSize: 13, minWidth: 200 }} autoFocus />
        <button onClick={() => onSaveRename(renamingMode)} style={{ padding: '7px 12px', background: '#DA9F54', color: '#000', border: 'none', borderRadius: 6, fontWeight: 700, cursor: 'pointer', fontSize: 12 }}>Kaydet</button>
        <button onClick={onCancelRename} style={{ padding: '7px 12px', background: '#666', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>İptal</button>
      </div>
    )}
  </div>
);

export default AkModesManager;
